import { Box, Button, Collapse, List, ListItem, ListItemText, Menu } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/authService";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { contactSelector } from "../../store/userSlice";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ExpandLess } from "@mui/icons-material";
import { useEffect } from "react";
import { GetPortalsNavigations } from "../../services/portalsService";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import InitialsBox from "../../modules/researchAuthorities/Components/InitialsBox";

const useStyles = makeStyles((theme) => ({
  profileMenu: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mixWidth: 220,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function ProfileMenu(props) {
  const { open } = props;
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [profileMenueAnchorEl, setAnchorEl] = useState(null);
  const [portals, setPortals] = useState([]);
  const [portalsOpen, setPortalsOpen] = useState(false);
  const contact = useSelector(contactSelector);
  const location = useLocation();

  useEffect(() => {
    GetPortalsNavigations().then((routes) => {
      setPortals(routes);
    });
  }, []);

  const openProfileMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const logout = () => {
    authService.logout();
    dispatch({ type: "USER_LOGGED_OUT" });
  };
  const shortenString = (str, length) => {
    if (!str) return;
    if (str.length > length) {
      return `${str.slice(0, length - 3)}...`;
    }
    return str;
  };
  const gotoPortal = (route) => {
    history.push(route);
  };
  const handleCloseProfileMenu = () => {
    setAnchorEl(null);
    setPortalsOpen(false);
  };
  const isActive = (route) => {
    const match = matchPath(location.pathname, route);
    return Boolean(match);
  };
  return (
    <Box className={classes.profileMenu}>
      <Button onClick={openProfileMenu} className={classes.initial}>
        <InitialsBox name={contact?.displayname} />
        {open ? (
          <Box mx={1}>{shortenString(contact?.displayname, 20)}</Box>
        ) : (
          ""
        )}
        {open ? <ExpandMoreIcon /> : ""}
      </Button>
      <Menu
        id="profile-menu"
        keepMounted
        open={Boolean(profileMenueAnchorEl)}
        onClose={handleCloseProfileMenu}
        anchorEl={profileMenueAnchorEl}
      >
        <ListItem
          button
          onClick={handleCloseProfileMenu}
          style={{ minWidth: 220 }}
        >
          <ListItemText primary="Profile" />
        </ListItem>
        <ListItem button onClick={handleCloseProfileMenu}>
          <ListItemText primary="Account" />
        </ListItem>
        <ListItem button onClick={() => setPortalsOpen(!portalsOpen)}>
          <ListItemText primary="Portals" />
          {portalsOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={portalsOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {portals.map((p) => (
              <ListItem
                button
                className={classes.nested}
                key={p.route}
                onClick={() => gotoPortal(p.route)}
                disabled={isActive(p.route)}
              >
                <ListItemText primary={p.name} />
              </ListItem>
            ))}
          </List>
        </Collapse>
        <ListItem button onClick={logout}>
          <ListItemText primary="Logout" />
        </ListItem>
      </Menu>
    </Box>
  );
}
